import styled from 'styled-components'

export const Notes = styled.span`
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 250px;
  overflow: hidden;
  display: block;
`

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  span {
    font: var(--theme-typography-bodyS-regular);
    color: var(--theme-colors-global-grey-grey700);
  }
`
